import { APPLICATION_ACTION_TYPES } from 'store/actions/application.actions';

const initialState = {
  studyIdentification: {},
  researchSite: {},
  clinicalLaboratoryFacility: {},
  eligiblePersonnelResponsible: {},
  contactPoint: {},
  institutionOfficial: {},
  clinicalSummary: {},
  chemistryPanelTest: {},
  informationRelated: {},
  completeBloodCount: {},
  liverFunctionTest: {},
  kidneyFunctionTest: {},
  tumorMarkers: {},
  geneticVariantFound: {},
  genomicFindings: {},
  bloodPresureHistology: {},
  eligibilityCriteria: {},
  additionalPatients: {},
  irbIec: {},
  studyCoordinator: {},
  submissionOfApplication: {},
  applicationVersion: 2,
  processing: false,
};

export default (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case APPLICATION_ACTION_TYPES.APPLICATION_SET_DATA_BY_KEY:
      return { ...state, [payload.stateKeyForDataSaving]: { ...payload.data } };
    case APPLICATION_ACTION_TYPES.APPLICATION_CHANGE_PROCESSING:
      return {
        ...state,
        processing: payload,
      };
    case APPLICATION_ACTION_TYPES.APPLICATION_CLEAR_STATE:
      if (payload.shouldDeleteProperty) {
        const { [payload.clearedKey]: clearedKey, ...stateTail } = state;
        return { ...stateTail };
      } else {
        return { ...state, [payload.clearedKey]: {} };
      }
    default:
      return state;
  }
};
